import React from "react";

const CreditCardSvg = ({ className }) => {
  return (
    <div className={className + " icon icon-shape text-center"}>
      <svg
        className="text-danger"
        width="43px"
        height="20px"
        viewBox="0 0 43 36"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>credit-card</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-2169.000000, -745.000000)"
            fill="#FFFFFF"
            fillRule="nonzero"
          >
            <g transform="translate(1716.000000, 291.000000)">
              <g id="credit-card" transform="translate(453.000000, 454.000000)">
                <path
                  className="color-background"
                  d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z"
                  opacity="0.593633743"
                />
                <path
                  className="color-foreground"
                  d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default CreditCardSvg;
